import { createFileRoute } from "@tanstack/react-router";
import { FulfillmentsView } from "./(fulfillments)/-components/view";

export const Route = createFileRoute(
  "/(reservations)/reservations/$id/fulfillments",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  return <FulfillmentsView id={id} />;
}
